export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';

export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';

export const PROJECTS_LOADED = 'PROJECTS_LOADED';
export const PROJECT_LOAD_FAILED = 'PROJECT_LOAD_FAILED';
export const SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT';
export const CREATE_PROJECT = 'CREATE_PROJECT';
export const PROJECT_CREATE_FAILED = 'PROJECT_CREATE_FAILED';

export const TICKETS_LOADED = 'TICKETS_LOADED';
export const TICKETS_LOAD_FAILED = 'TICKETS_LOAD_FAILED';
export const TICKET_UPDATED = 'TICKET_UPDATED';
export const TICKET_UPDATE_FAILED = 'TICKET_UPDATE_FAILED';
export const LOAD_TICKET = 'LOAD_TICKET';
export const DELETE_TICKET = 'DELETE_TICKET';
export const DELETE_TICKET_FAILED = 'DELETE_TICKET_FAILED';
export const TICKET_CREATED = 'TICKET_CREATED';
export const FIND_TICKET_CREATOR = 'FIND_TICKET_CREATOR';

export const COMMENT_ADDED = 'COMMENT_ADDED';
export const COMMENTS_LOADED = 'COMMENTS_LOADED';
export const COMMENTS_LOAD_FAILED = 'COMMENTS_LOAD_FAILED';
export const DELETE_COMMENT = 'DELETE_COMMENT';
